import { Toaster } from '@creditsights/styleguide-web';
import React from 'react';
import { useToast } from '../../hooks/toast/useToast';

const Toast = (): JSX.Element | null => {
  const { toastParams, hideToast } = useToast();
  const textContent = toastParams?.textContent;
  if (textContent && hideToast) {
    return <Toaster textContent={textContent} onClose={hideToast} mode={toastParams?.mode} />;
  }
  return null;
};

export default Toast;
